<ng-container *ngIf="deliveries">
  <table class="table table-compact" *ngIf="deliveries.length > 0">
    <thead>
    <tr>
      <th class="left" *ngIf="!posList">Lieferschein</th>
      <th class="left" *ngIf="posList">Position</th>
      <th class="left">Bezeichnung</th>
      <th class="left">Beschreibung</th>
      <th class="left">Material</th>
      <th class="right">Kennzeichnung</th>
      <th class="right">Anzahl</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let delivery of deliveries">
      <td class="left" *ngIf="!posList" [routerLink]="['/delivery/details', delivery.project_id, jobid, delivery.delivery_id]">{{ delivery.project_id }}.0004.{{ delivery.delivery_id }}</td>
      <td class="left" *ngIf="posList">{{ delivery.position }}<span *ngIf="(delivery?.part || 0) > 0">.{{ (delivery?.part || 0) }}</span></td>
      <td class="left">{{ delivery.name }}</td>
      <td class="left">{{ delivery.description }}</td>
      <td class="left">{{ delivery.material }}</td>
      <td class="right">{{ delivery.serial_nr }}</td>
      <td class="right"><span *ngIf="(delivery?.number_of_pieces || 0) > 0">{{ (delivery?.number_of_pieces || 0) }}</span></td>
    </tr>
    </tbody>
  </table>
</ng-container>
